import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'Plan de Arranque en 10 Minutos',
  desc: 'Empezá hoy mismo sin improvisar, con pasos exactos.',
  image: 'https://cdn.magicpatterns.com/uploads/kvfM1EpgZcK4NXQq7VphV3/Captura_de_pantalla_2026-06-19_001850.webp'
}, {
  num: 2,
  title: 'Mapa de Progreso del Expedicionario',
  desc: 'Un tablero visual para que marque cada avance y se motive.',
  image: 'https://cdn.magicpatterns.com/uploads/oWddef2F7fVEGR51aBrx6A/Captura_de_pantalla_2026-06-19_001902.webp'
}, {
  num: 3,
  title: 'Frases que Motivan sin Presionar',
  desc: 'Las frases justas para sumarlo sin peleas ni gritos.',
  image: 'https://cdn.magicpatterns.com/uploads/r8oLPZ8aazhubv5xkRi3L2/Captura_de_pantalla_2026-06-19_001952.webp'
}, {
  num: 4,
  title: 'Checklist Anti-Pantalla para Vacaciones',
  desc: 'Límites claros a las pantallas, sin conflictos.',
  image: 'https://cdn.magicpatterns.com/uploads/9N7qVtVCsoTnUWjYYwajhU/Captura_de_pantalla_2026-06-19_002002.webp'
}, {
  num: 5,
  title: 'Diploma de Honor para el Primer Día',
  desc: 'El cierre épico: un diploma premium por su esfuerzo.',
  image: 'https://cdn.magicpatterns.com/uploads/iHHPca1T8ZbrpSDj7peowH/Captura_de_pantalla_2026-06-19_001826.webp'
}];
export function BonusesSection() {
  return <section className="py-12 md:py-16 bg-transparent" data-id="element-12">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-13">
        <div className="text-center mb-10" data-id="element-14">
          <span className="inline-flex items-center gap-2 px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#7d8a6e] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-15">
            <Gift className="w-4 h-4 text-[#d4a017]" data-id="element-16" />5 Bonos Incluidos
          </span>
          <h2 className="font-heading font-bold text-[#2f3a2c] text-3xl md:text-5xl leading-tight" data-id="element-17">
            Y además, recibe{' '}
            <span className="italic text-[#6f7a64]" data-id="element-18">5 bonos de lujo</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 mb-10" data-id="element-19">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white border border-slate-200 rounded-2xl p-3 shadow-sm" data-id="element-20">
              <div className="relative rounded-xl overflow-hidden mb-3" data-id="element-21">
                <img src={b.image} alt={`Bono ${b.num}: ${b.title}`} width={500} height={500} loading="lazy" decoding="async" sizes="(max-width: 640px) 90vw, 320px" className="w-full h-auto block" data-id="element-22" />
                <span className="absolute top-2.5 left-2.5 bg-rose-500 text-white font-bold text-[11px] tracking-wide uppercase px-2.5 py-1 rounded-md shadow-sm" data-id="element-23">
                  Bonus {b.num}
                </span>
                <span className="absolute top-2.5 right-2.5 inline-flex items-center gap-1 bg-emerald-600 text-white font-bold text-[11px] tracking-wide uppercase px-2.5 py-1 rounded-md shadow-sm" data-id="element-24">
                  🎁 Gratis
                </span>
              </div>
              <div className="px-2 pb-2" data-id="element-25">
                <h3 className="font-heading font-bold text-[#2f3a2c] text-xl mb-1.5" data-id="element-26">
                  {b.title}
                </h3>
                <p className="text-slate-500 text-sm leading-snug" data-id="element-27">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center px-6 py-10 bg-white/60 border border-amber-100 rounded-3xl" data-id="element-28">
          <Gift className="w-9 h-9 text-[#d4a017] mx-auto mb-4" data-id="element-29" />
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#6f7a64] mb-2" data-id="element-30">
            Todo incluido en
          </p>
          <h3 className="font-heading font-bold text-[#2f3a2c] text-3xl md:text-4xl mb-3" data-id="element-31">
            el Pack 6 en 1
          </h3>
          <p className="text-slate-600" data-id="element-32">
            Los 5 bonos son gratis con tu compra hoy.
          </p>
        </div>
      </div>
    </section>;
}